module.exports = __webpack_public_path__ + "img/ee.d0b72825.svg";